import {ActionOnStart} from "../enum/activity.enum";

export const onStartActions = [ActionOnStart.NONE, ActionOnStart.STOP, ActionOnStart.PAUSE];
